<template>
  <div class="animated">
    <i class="icon-basket mr-1"></i> Products
    <b-btn :to="{ name: 'businessItemForm' }" size="sm" class="float-right mb-2">
      <i class="fa fa-plus"></i> Add New
    </b-btn>
    <hr />
    <v-client-table
      class="vue-table-table bg-light p-2"
      name="dataTableBusinessItemList"
      :columns="columns"
      :data="businessItems"
      :options="options"
      :theme="theme"
      id="table-business-items"
      :preserveState="preserveState"
    >
      <template slot="price" slot-scope="props">
        {{ formatPrice(props.row.price) }}
      </template>
      <template slot="isActive" slot-scope="props">
        <b-badge :variant="props.row.isActive ? 'success' : 'secondary'">
          {{ props.row.isActive ? 'Active' : 'Inactive' }}
        </b-badge>
      </template>
      <div slot="actions" slot-scope="props" class="text-center">
        <b-button-group>
          <b-btn
            size="sm"
            variant="warning"
            :to="{ name: 'businessItemForm', params: { iid: props.row.id } }"
          >Edit</b-btn>
          <b-btn size="sm" variant="danger" @click="removeBusinessItem(props.row)">Delete</b-btn>
        </b-button-group>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ClientTable } from 'vue-tables-2-premium'

Vue.use(ClientTable)

export default {
  name: 'BusinessItemList',
  data () {
    return {
      columns: ['name', 'price', 'sku', 'stockQuantity', 'isActive', 'actions'],
      options: {
        headings: {
          name: 'Name',
          price: 'Price',
          sku: 'SKU',
          stockQuantity: 'Stock',
          isActive: 'Status',
          actions: 'Action'
        },
        sortable: ['name', 'price', 'sku', 'stockQuantity', 'isActive'],
        filterable: ['name', 'sku'],
        sortIcon: { base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        }
      },
      preserveState: true,
      theme: 'bootstrap4'
    }
  },
  computed: {
    ...mapGetters(['business', 'businessItems'])
  },
  methods: {
    ...mapActions(['getBusinessItems', 'deleteBusinessItem']),
    formatPrice (price) {
      return Number(price || 0).toFixed(2)
    },
    loadBusinessItems () {
      if (!this.business || !this.business.id) {
        return Promise.resolve([])
      }
      return this.getBusinessItems({
        business: this.business.id,
        pagination: false
      })
    },
    removeBusinessItem (item) {
      if (!confirm('Delete this business item?')) {
        return
      }
      this.deleteBusinessItem(item.id).then(() => {
        this.loadBusinessItems()
        this.showSuccess()
      })
    }
  },
  created () {
    this.loadBusinessItems()
  },
  destroyed () {
    this.$store.commit('SET_BUSINESS_ITEMS', [])
  }
}
</script>
